import { GetterTree } from 'vuex'
import { RootState } from '@/store'
import { PipelineConnectionsState } from './index'
import { PipelineConnection } from '@/api/model/pipeline-connection'
import { Pipeline } from '@/api/model/pipeline'
import { Company } from '@/api/model/company'

function incomingConnections(state: PipelineConnectionsState): PipelineConnection[] {
    return state.incomingConnections
        .filter(connection => connection.isActive)
}

function outgoingConnections(state: PipelineConnectionsState): PipelineConnection[] {
    return state.outgoingConnections
        .filter(connection => connection.isActive)
}

function incomingPipelines(state: PipelineConnectionsState): Pipeline[] {
    return incomingConnections(state)
        .filter(connection => connection.pipeline !== null)
        .map(connection => connection.pipeline)
}

function outgoingPipelines(state: PipelineConnectionsState): Pipeline[] {
    return outgoingConnections(state)
        .filter(connection => connection.pipeline !== null)
        .map(connection => connection.pipeline)
}

function incomingCompanies(state: PipelineConnectionsState): Company[] {
    return incomingConnections(state)
        .map(connection => connection.sourceCompany)
}

function outgoingCompanies(state: PipelineConnectionsState): Company[] {
    return outgoingConnections(state)
        .map(connection => connection.targetCompany)
}

function availableConnections(state: PipelineConnectionsState): PipelineConnection[] {
    return [
        ...incomingConnections(state),
        ...outgoingConnections(state),
    ]
}

function availablePipelines(state: PipelineConnectionsState): Pipeline[] {
    return [
        ...incomingPipelines(state),
        ...outgoingPipelines(state),

    ].filter((pipeline, index, self) => {
        return self.findIndex(p => p.id === pipeline.id) === index
    })
}

function availableCompanies(state: PipelineConnectionsState): Company[] {
    return [
        ...incomingCompanies(state),
        ...outgoingCompanies(state),
    ]
}

function availableOrderTypes(state: PipelineConnectionsState): string[] {
    const orderTypes: string[] = this.getCompanies(state)
        .flatMap(company => company.orderSettings.enabledTypes)

    return [...new Set(orderTypes)]
}


export const getters: GetterTree<PipelineConnectionsState, RootState> = {
    incomingConnections,
    outgoingConnections,
    incomingPipelines,
    outgoingPipelines,
    incomingCompanies,
    outgoingCompanies,
    availableConnections,
    availablePipelines,
    availableCompanies,
    availableOrderTypes,
}

